import pathfinder from '@fiverr-private/pathfinder';
import { translate } from '@fiverr-private/i18n-react';
import { DEFAULT_LOCALE } from '../../constants';

export const getBreadcrumbList = ({ type, id, name, isMonogramHubPage = false, locale = DEFAULT_LOCALE }) => {
    const breadcrumbsList = [
        {
            url: pathfinder('logo_maker_buyer_landing_page'),
            name: translate('logo_maker_perseus.general.logo_maker', {
                locale,
            }),
        },
        {
            url: pathfinder('logo_maker_discover_logo_ideas_page'),
            name: translate('logo_maker_perseus.general.logo_ideas', {
                locale,
            }),
        },
    ];

    if (type && name && id) {
        breadcrumbsList.push({
            url: pathfinder('logo_maker_buyer_ideas_page', {
                type,
                tag: id,
            }),
            name,
        });
    }

    if (isMonogramHubPage) {
        breadcrumbsList.push({
            url: pathfinder('logo_maker_monograms_logo_ideas_page'),
            name,
        });
    }

    return breadcrumbsList;
};
